import React, { Component, Fragment } from 'react';
import { CloseCircleFilled, PlusCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { Checkbox, Select } from 'antd';
import { createPortal } from 'react-dom';
import Panel from '@/components/Panel';
import { getPortByTouchstone } from '../../../../services/helper/getPortByTouchstone';
import TreeSelect from '../../../../components/TreeSelect';
import NetListModel from './socketModel';
import { IC, PACKAGE_FILE, SOCKET } from '../../../../services/Cascade/constants';
import ICModel from './ICModel';
import PkgModel from './pkgModel';
import { splitArrayToArrays } from '../../../../services/helper/arrayHelper';
import { getTouchstoneParse, getTreeSelectList } from '../../../../services/Cascade/library';
import { TOUCHSTONE, SPICE } from '../../../../services/Cascade/constants';
import '../../../../components/PackageModel_v1/index.css'
import './index.css'

const TOUCHSTONE_SPICE = "Touchstone / SPICE"
const modelTypeOptions = [TOUCHSTONE_SPICE]
class ModelPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      apply: false,
      subcktList: [],
      modelType: TOUCHSTONE_SPICE,
      selectFileList: [],
      pairs: []
    }
    this.dialogRoot = document.getElementById('root');
  }

  componentDidMount() {
    this.initData()
  }

  componentDidUpdate(prevProps) {
    const { touchstoneList, spiceList } = this.props;
    if (touchstoneList.length !== prevProps.touchstoneList.length || spiceList.length !== prevProps.spiceList.length) {
      this.initData()
    }
  }

  initData = () => {
    const { model, portList, touchstoneList, spiceList, type } = this.props
    const touchstoneSpiceList = [...touchstoneList, ...spiceList].map(item => getTreeSelectList(item))
    const files = model && model.files ? model.files : []
    const pairs = model && model.pairs ? model.pairs : []
    const { trueArray: tagArray, falseArray } = splitArrayToArrays({ array: touchstoneSpiceList, rule: (item) => item.tag === type })
    this.setState({
      files,
      pairs: pairs && pairs.length ? this.updateDefaultPairs(pairs, portList) : this.getDefaultPairs(portList),
      touchstoneSpiceList: [...tagArray, ...falseArray]
    }, () => {
      this.getFileAndParse(files)
    })
  }

  getDefaultPairs = (portList) => {
    const { type } = this.props;
    switch (type) {
      case SOCKET:
        return portList.reduce((acc, { index, leftPorts, rightPorts }) => {
          if (leftPorts) {
            leftPorts.forEach(leftPort => {
              acc.push({
                ...leftPort,
                index,
                node: "",
                subckt: "",
                libraryId: "",
                modelKey: ""
              })
            })
          }
          if (rightPorts) {
            rightPorts.forEach(rightPort => {
              acc.push({
                ...rightPort,
                index,
                node: "",
                subckt: "",
                libraryId: "",
                modelKey: ""
              })
            })
          }
          return acc;
        }, [])
      case IC:
        return portList.map(port => ({
          ...port,
          nodes: [],
          subckt: "",
          libraryId: "",
          modelKey: "",
          type: "left"
        }))
      case PACKAGE_FILE:
        return portList.map(port => ({
          ...port,
          nodes: [],
          subckt: "",
          libraryId: "",
          modelKey: "",
        })).filter(port => port.type === 'left')
      default:
        return []
    }
  }

  updateDefaultPairs = (pairs, portList) => {
    const { type } = this.props;
    if (type === IC) {
      const leftPorts = pairs.filter(item => item.type === 'left');
      if (leftPorts.length !== portList.length) {
        const rightPorts = pairs.filter(item => item.type === 'right');
        return [
          ...portList.map(port => {
            const find = leftPorts.find(item => item.port === port.port);
            return find || {
              ...port,
              nodes: [],
              subckt: "",
              libraryId: "",
              modelKey: "",
            }
          }),
          ...rightPorts
        ]
      }
    }
    return pairs;
  }

  getFileAndParse = async (files) => {
    let _selectFileList = [];
    for (let index = 0; index < files.length; index++) {
      const file = files[index];
      let fileInfo = {
        modelKey: `${index + 1}`,
        fileName: file ? file.fileName : "",
        libraryId: file ? file.libraryId : "",
        type: file ? file.type : "",
        subckt: file ? file.subckt : "",
        nodes: [],
        notes: []
      };

      if (file.type === SPICE) {
        try {
          const res = await this.props.getPkgSpiceModelList(file.libraryId, file.fileName, "SPICE");
          if (res && res.models && Array.isArray(res.models)) {
            fileInfo.subcktList = [...res.models];
            if (fileInfo.subckt) {
              const subcktInfo = fileInfo.subcktList.find(item => item.name === fileInfo.subckt)
              fileInfo.nodes = subcktInfo ? subcktInfo.ports : []
            } else if (fileInfo.subcktList.length === 1) {
              fileInfo.subckt = fileInfo.subcktList[0].name;
              fileInfo.nodes = fileInfo.subcktList[0].ports;
            }
          }
        } catch (error) {
          console.error(error);
        }
      } else if (file.type === TOUCHSTONE) {
        fileInfo.nodes = getPortByTouchstone(file.fileName);
        const tsInfo = await getTouchstoneParse(file.libraryId, file.fileName);
        fileInfo.notes = tsInfo ? tsInfo.ports : []
      }
      _selectFileList.push(fileInfo);
    }
    this.setState({ selectFileList: _selectFileList });
  }

  closeModal = () => {
    const { files, pairs } = this.state
    this.props.closeModal({ files, pairs })
    if (this.props.save) {
      this.props.save()
    }
  }

  changeApply = () => {
    this.setState({
      apply: !this.state.apply
    })
  }

  applyRender = () => {
    const { apply } = this.state;
    return <div className="imp-current-apply">
      <Checkbox
        checked={apply}
        onChange={this.changeApply}
      />
      <span>
        Apply model to all Ports
      </span>
    </div>
  }

  onRef = (ref) => {
    this.modelChild = ref;
  }

  initPairs = () => {
    const { portList } = this.props
    const portPairs = this.getDefaultPairs(portList)
    this.setState({
      pairs: portPairs
    }, () => {
      this.modelChild && this.modelChild.initPortList()
    })
  }

  updateFiles = (selectedFiles) => {
    const files = selectedFiles.map(item => {
      return {
        fileName: item.fileName || "",
        libraryId: item.libraryId || "",
        modelKey: item.modelKey || "1",
        subckt: item.subckt || "",
        type: item.type || ""
      }
    })
    this.setState({
      files
    })
  }

  updatePortList = (prevFileInfo) => {
    if (prevFileInfo) {
      const { pairs } = this.state
      const { type } = this.props;
      let _pairs = JSON.parse(JSON.stringify(pairs))
      if (type === PACKAGE_FILE) {
        _pairs = _pairs.filter(item => {
          if (item.type === 'left') {
            if (item.libraryId === prevFileInfo.libraryId && item.modelKey === prevFileInfo.modelKey) {
              item.libraryId = "";
              item.subckt = "";
              item.nodes = [];
              item.modelKey = "";
            }
            return true;
          } else if (item.type === 'right') {
            return !(item.libraryId === prevFileInfo.libraryId && item.modelKey === prevFileInfo.modelKey);
          }
          return true;
        });
      } else {
        _pairs.forEach(item => {
          if (item.libraryId === prevFileInfo.libraryId && item.modelKey === prevFileInfo.modelKey) {
            item.libraryId = ""
            item.subckt = ""
            if (type === IC) {
              item.nodes = []
            } else {
              item.node = ""
            }
            item.modelKey = ""
          }
        });
      }
      this.setState({
        pairs: _pairs
      }, () => {
        this.modelChild && this.modelChild.initPortList()
      })
    }
  }

  selectModelFile = async (key, index) => {
    const { selectFileList, touchstoneSpiceList } = this.state;
    const { type } = this.props;
    const _selectFileList = [...selectFileList];
    const prevFileInfo = selectFileList[index];

    const name = key.id ? key.name : key;
    const model = key.id ? { ...key } : touchstoneSpiceList.find(item => item.name === name);

    if (!model) return;

    let fileInfo = {
      modelKey: `${index + 1}`,
      fileName: name,
      libraryId: model.id || "",
      type: model.modelType,
      subckt: "",
      nodes: [],
      notes: []
    };

    if (model.modelType === SPICE) {
      try {
        const res = await this.props.getPkgSpiceModelList(model.id, model.name, "SPICE");
        if (res && res.models && Array.isArray(res.models)) {
          fileInfo.subcktList = [...res.models];
          if (fileInfo.subcktList.length === 1) {
            fileInfo.subckt = fileInfo.subcktList[0].name;
            fileInfo.nodes = fileInfo.subcktList[0].ports;
          }
        }
      } catch (error) {
        console.error(error);
      }
    } else if (model.modelType === TOUCHSTONE) {
      fileInfo.nodes = getPortByTouchstone(name);
      const tsInfo = await getTouchstoneParse(model.id, name);
      fileInfo.notes = tsInfo ? tsInfo.ports : []
    }

    this.updatePortList(prevFileInfo)
    _selectFileList[index] = fileInfo;
    this.updateFiles(_selectFileList);
    this.setState({
      selectFileList: _selectFileList
    }, () => {
      if (this.modelChild && this.modelChild.autoSetPorts) {
        if (type !== PACKAGE_FILE || _selectFileList.length === 1) {
          this.modelChild.autoSetPorts(fileInfo)
        }
      }
    });
  };

  selectSpiceSubckt = (subcktName, index) => {
    const { selectFileList } = this.state;
    const _selectFileList = [...selectFileList];
    const prevFileInfo = selectFileList[index]

    let fileInfo = { ..._selectFileList[index] };
    if (!fileInfo || !fileInfo.subcktList) return;

    const selectedSubckt = fileInfo.subcktList.find(subckt => subckt.name === subcktName);
    if (!selectedSubckt) return;

    fileInfo.subckt = selectedSubckt.name;
    fileInfo.nodes = selectedSubckt.ports || [];

    _selectFileList[index] = fileInfo;
    this.updatePortList(prevFileInfo)
    this.updateFiles(_selectFileList);
    this.setState({ selectFileList: _selectFileList }, () => {
      if (this.modelChild && this.modelChild.autoSetPorts) {
        this.modelChild.autoSetPorts(fileInfo)
      }
    });
  };

  deleteFileSelect = (target, index) => {
    const { selectFileList } = this.state;
    const _selectFileList = [...selectFileList];
    const prevFileInfo = selectFileList[index]
    if (target === 'file') {
      _selectFileList[index] = {
        modelKey: `${index + 1}`,
        nodes: [],
        fileName: '',
        libraryId: '',
        subckt: '',
        subcktList: [],
      };
    } else if (target === 'subckt') {
      _selectFileList[index] = {
        ..._selectFileList[index],
        nodes: [],
        subckt: '',
      };
    }
    this.updatePortList(prevFileInfo)
    this.updateFiles(_selectFileList);
    this.setState({ selectFileList: _selectFileList });
  }

  changeModelType = (value) => {

  }

  updatePairs = (pairs) => {
    this.setState({
      pairs
    })
  }

  addNewFileSelect = (e) => {
    e && e.stopPropagation()
    const { selectFileList } = this.state;
    let _selectFileList = [...selectFileList];
    if (_selectFileList.length === 0) {
      _selectFileList = [
        {
          modelKey: "1",
          nodes: [],
          fileName: '',
          libraryId: '',
          subckt: '',
          subcktList: [],
        },
        {
          modelKey: "2",
          nodes: [],
          fileName: '',
          libraryId: '',
          subckt: '',
          subcktList: [],
        }
      ];
    } else {
      const newModelKey = String(_selectFileList.length + 1);
      _selectFileList.push({
        modelKey: newModelKey,
        nodes: [],
        fileName: '',
        libraryId: '',
        subckt: '',
        subcktList: [],
      });
    }
    this.updateFiles(_selectFileList);
    this.setState({ selectFileList: _selectFileList });
  }

  deleteModelSelect = (index) => {
    const { selectFileList } = this.state;
    const _selectFileList = [...selectFileList];
    const prevFileInfo = selectFileList[index]
    if (index < 0 || index >= _selectFileList.length) return;
    _selectFileList.splice(index, 1);
    _selectFileList.forEach((file, i) => {
      file.modelKey = String(i + 1);
    });

    this.updatePortList(prevFileInfo)

    if (!_selectFileList.length) {
      this.initPairs()
    }

    this.updateFiles(_selectFileList);
    this.setState({ selectFileList: _selectFileList });
  };

  modelTitle = () => {
    const { type } = this.props;
    switch (type) {
      case SOCKET:
        return "Socket Model";
      case PACKAGE_FILE:
        return "Package Model";
      case IC:
        return "IC Package Model";
      default:
        return "";
    }
  }

  nodeRender = () => {
    const { portList, type, overviewReverse, leftModelTitle, rightModelTitle } = this.props;
    const { nodes, selectFileList, pairs } = this.state
    if (!pairs || !pairs.length) {
      return;
    }
    switch (type) {
      case SOCKET:
        return <NetListModel
          onRef={this.onRef}
          portList={portList}
          nodes={nodes}
          selectFileList={selectFileList}
          pairs={pairs}
          updatePairs={this.updatePairs}
          initPairs={this.initPairs}
          leftModelTitle={leftModelTitle}
          rightModelTitle={rightModelTitle}
          overviewReverse={overviewReverse}
        />
      case IC:
        return <ICModel
          onRef={this.onRef}
          portList={portList}
          nodes={nodes}
          selectFileList={selectFileList}
          pairs={pairs}
          updatePairs={this.updatePairs}
          initPairs={this.initPairs}
        />
      case PACKAGE_FILE:
        return <PkgModel
          onRef={this.onRef}
          portList={portList}
          nodes={nodes}
          selectFileList={selectFileList}
          pairs={pairs}
          updatePairs={this.updatePairs}
          initPairs={this.initPairs}
          overviewReverse={overviewReverse}
        />
      default:
        return null;
    }
  }

  renderDialog = () => {
    const { modelType, selectFileList, touchstoneSpiceList } = this.state
    const { type } = this.props
    const content = (
      <Panel
        className='cascade-panel'
        id='cascade-panel'
        title={this.modelTitle()}
        onCancel={this.closeModal}
        zIndex={2000}
        width={type === SOCKET ? 794 : 694}
        minWidth={300}
        minHeight={200}
        position='panel-center-left'
        draggable
        overflow={"auto"}
      >
        <div className='cascade-model-content'>
          <div className='cascaede-model-select'>
            <span>Model Type</span>
            <Select
              value={modelType}
              onChange={this.changeModelType}
              className='cascaede-model-selection'
              popupClassName='netlist-model-dropdown'
              getPopupContainer={() => document.getElementById('root')}
              options={modelTypeOptions.map(item => ({
                value: item,
                label: item
              }))}
            />
          </div>
          {(selectFileList.length > 0 ? selectFileList : [{}]).map((item, index) => {
            return <div className='cascaede-model-select' key={index}>
              <div className='spice-model-file-add-box'>
                {index === 0 && <Fragment>
                  <span>Model File</span>
                  {
                    ![IC].includes(type) ? <PlusCircleOutlined
                      title={'Add new file'}
                      className='spice-model-add-file-icon'
                      onClick={(e) => { this.addNewFileSelect(e) }}
                    /> : null
                  }
                </Fragment>}
              </div>
              <TreeSelect
                showSearch
                value={item.fileName || ''}
                onSelectItem={(key) => this.selectModelFile(key, index)}
                className={`cascaede-model-selection ${item.type === SPICE ? "cascaede-model-selection-50" : ""}`}
                popupClassName='netlist-model-dropdown'
                popupMatchSelectWidth={false}
                allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => this.deleteFileSelect('file', index)} /> }}
                getPopupContainer={() => document.getElementById('root')}
                fileList={touchstoneSpiceList}
                selected={`${item.libraryId || ''}-${item.fileName || ''}`}
                selectedkey={"key"}
              />
              {item.type === SPICE && (
                <Select
                  style={{ marginLeft: "10px" }}
                  value={item.subckt || ''}
                  onSelect={(key) => this.selectSpiceSubckt(key, index)}
                  className='cascaede-model-selection cascaede-model-selection-50'
                  popupClassName='netlist-model-dropdown'
                  allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => { this.deleteFileSelect('subckt', index) }} /> }}
                  getPopupContainer={() => document.getElementById('root')}
                  options={item.subcktList.map(subckt => ({
                    value: subckt.name,
                    label: subckt.name,
                    disabled: subckt.disabled,
                    title: subckt.disabled ? 'The number of ports should be two' : ''
                  }))}
                />
              )}
              {selectFileList.length > 0 &&
                <CloseOutlined
                  title="Delete Model"
                  onClick={(e) => this.deleteModelSelect(index)}
                  className="spice-netlist-model-title-pcb-delete-icon"
                />
              }
            </div>
          })}
          {this.nodeRender()}
        </div>
      </Panel>
    );
    return createPortal(content, this.dialogRoot);
  }

  render() {
    return <Fragment>
      {this.renderDialog()}
    </Fragment>
  }
}

export default ModelPanel;
